module.exports = {
	RECEIVE_ALL_SELECTIONS: 'RECEIVE_SELECTIONS',
	RECEIVE_SELECTIONS_FILTERS: 'RECEIVE_SELECTIONS_FILTERS',
	RECEIVE_FILTERS_VALUES: 'RECEIVE_FILTERS_VALUES',
	RECEIVE_SELECTIONS_SITES: 'RECEIVE_SELECTIONS_SITES',
	RECEIVE_SELECTIONS_DETAIL_SITES: 'RECEIVE_SELECTIONS_DETAIL_SITES',
	RESET_USER_SELECTION: 'RESET_USER_SELECTION',
	SELECTED_SELECTION: 'SELECTED_SELECTION',
	SELECTED_SELECTION_INFORMATION: 'SELECTED_SELECTION_INFORMATION',
	RESET_SELECTED_SELECTION_INFORMATION: 'RESET_SELECTED_SELECTION_INFORMATION',
	OPEN_MODAL_SELECTED_SELECTION_INFORMATION: 'OPEN_MODAL_SELECTED_SELECTION_INFORMATION',
	OPEN_MODAL_SELECTED_SELECTION_DELETE: 'OPEN_MODAL_SELECTED_SELECTION_DELETE',
	OPEN_MODAL_SELECTED_SELECTION_EXPORT: 'OPEN_MODAL_SELECTED_SELECTION_EXPORT',
	OPEN_MODAL_SELECTED_SELECTION_SAVE: 'OPEN_MODAL_SELECTED_SELECTION_SAVE',
	CLOSE_MODAL_SELECTED_SELECTION_INFORMATION: 'CLOSE_MODAL_SELECTED_SELECTION_INFORMATION',
	CLOSE_MODAL_SELECTED_SELECTION_DELETE: 'CLOSE_MODAL_SELECTED_SELECTION_DELETE',
	CLOSE_MODAL_SELECTED_SELECTION_EXPORT: 'CLOSE_MODAL_SELECTED_SELECTION_EXPORT',
	CLOSE_MODAL_SELECTED_SELECTION_SAVE: 'CLOSE_MODAL_SELECTED_SELECTION_SAVE',
	RESET_SELECTED_SELECTION: 'RESET_SELECTED_SELECTION',
	RECEIVE_SELECTIONS_KEY_FIGURES: 'RECEIVE_SELECTIONS_KEY_FIGURES',
	RECEIVE_SELECTIONS_EXPORT_HISTORY: 'RECEIVE_SELECTIONS_EXPORT_HISTORY',
	RECEIVE_SELECTIONS_WATERSHED: 'RECEIVE_SELECTIONS_WATERSHED',
	RECEIVE_SELECTIONS_STATUS: 'RECEIVE_SELECTIONS_STATUS',
	RECEIVE_DELETE_SELECTION: 'RECEIVE_DELETE_SELECTION',
	RECEIVE_AND_SELECT_SELECTION: 'RECEIVE_AND_SELECT_SELECTION',
	RECEIVE_REMOVE_FAVORITE_SELECTION: 'RECEIVE_REMOVE_FAVORITE_SELECTION',
	RECEIVE_FAVORITE_SELECTION: 'RECEIVE_FAVORITE_SELECTION',
	RECEIVE_SELECTED_EXPORT_SELECTIONS: 'RECEIVE_SELECTED_EXPORT_SELECTIONS',
	RESET_SELECTED_EXPORT_SELECTIONS: 'RESET_SELECTED_EXPORT_SELECTIONS',
	RESET_SELECTION_INFORMATIONS: 'RESET_SELECTION_INFORMATIONS',
	SITE_DESCRIPTION_EXPORT_OPTION: 'SITE_DESCRIPTION',
	SITE_DATA_EXPORT_OPTION: 'SITE_DATA'
}



// WEBPACK FOOTER //
// ./src/dashboard/constants/SelectionConstants.js